import { Key, ReactNode } from "react";
import { CascaderOption, CascaderValueType } from "./interface";

/** 拉平所有选项 */
export function flatCascaderOptions(cascaderOptions?: CascaderOption[], parentValues: Key[] = [], parentLabels: ReactNode[] = []): CascaderOption[] {
  const flatOptions: CascaderOption[] = [];
  if (Array.isArray(cascaderOptions) && cascaderOptions.length) {
    cascaderOptions.forEach(cascaderOption => {
      const { children, ...restCascaderOption} = cascaderOption;
      const cascaderValue = [...parentValues, cascaderOption.value];
      const cascaderLabel = [...parentLabels, cascaderOption.label];
      flatOptions.push({...restCascaderOption, cascaderValue, cascaderLabel});
      if (Array.isArray(children) && children.length) {
        flatOptions.push(...flatCascaderOptions(children, cascaderValue, cascaderLabel));
      }
    });
  }
  return flatOptions;
}
/** 根据子选项的value，生成完整的value数组 */
export function cascaderValueToValue(cascaderValue?: CascaderValueType, flatOptions?: CascaderOption[]) {
  if (!cascaderValue || !flatOptions || (Array.isArray(flatOptions) && !flatOptions.length)) return;
  let values: any[] = [];
  if (Array.isArray(cascaderValue)) {
    const findOptions = flatOptions.filter(item => cascaderValue.includes(item.value));
    findOptions.forEach(option => {
      values.push(option.cascaderValue);
    });
  } else {
    const findOption = flatOptions.find(item => cascaderValue === item.value);
    return findOption?.cascaderValue;
  }
  return values;
}
/**
 * 将接口返回数据转换为options
 * @param data 数据
 * @param labelKey label字段
 * @param valueKey value字段
 * @param childrenKey children字段
 * @param level 当前层级
 * @param childrenLabelKey 子节点label字段
 * @param childrenValueKey 子节点value字段
 * @param maxLevel 最多展示到第几层级
 * @returns 
 */
export function dataToOptions(
  data: any,
  labelKey: string = 'label',
  valueKey: string = 'value',
  childrenKey: string = 'children',
  level: number,
  childrenLabelKey?: string,
  childrenValueKey?: string,
  maxLevel?: number,
): CascaderOption[] {
  const options: CascaderOption[] = [];
  if (maxLevel && level > maxLevel) return options;
  if (Array.isArray(data) && data.length) {
    data.forEach(option => {
      const {[labelKey]: label, [valueKey]: value, [childrenKey]: children, ...restOption} = option;
      if (Array.isArray(children) && children.length) {
        const childrenOption = dataToOptions(children, childrenLabelKey || labelKey, childrenValueKey || valueKey, childrenKey, level + 1, childrenLabelKey, childrenValueKey, maxLevel);
        options.push({...restOption, label, value, children: childrenOption});
      } else {
        options.push({...restOption, label, value});
      }
    });
  }
  return options;
}